import { MAIN_ROLES } from "config";
import { useAuth } from "context/AuthContext"

export const useCheckMenuPermission = () => {
    const { user } = useAuth();
    
    const allPermissions = user?.permission?.flatMap(mod => mod?.permissions || []);

    const hasRoleCheck = () => MAIN_ROLES?.filter(name => user?.roles?.includes(name))?.length;

    const hasPermission = (permKey) => {
        if (hasRoleCheck()) return true;

        const permissions = user?.permission?.flatMap(mod => mod?.permissions || []);

        return permKey?.some((name) => permissions?.includes(name));
    };

    return { allPermissions, hasPermission, hasRoleCheck };

};
